"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Button = (_a) => {
    var { color = 'primary', outline = false, size, active = false, block = false, className = '', children } = _a, props = __rest(_a, ["color", "outline", "size", "active", "block", "className", "children"]);
    const buttonClasses = (0, classnames_1.default)('btn', {
        [`btn-${color}`]: !outline,
        [`btn-outline-${color}`]: outline,
        [`btn-${size}`]: size,
        'btn-block': block,
        active: active,
    }, className);
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({ className: buttonClasses }, props, { children: children })));
};
exports.Button = Button;
